import React from 'react'
import styled from 'styled-components'

import { colors } from '@/styles'
import { H5 } from '@/components/text'

const SectionWrapper = styled.section<{
  customGap?: string
  showBottomSeparator?: boolean
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  gap: ${props => (props.customGap ? props.customGap : '24px')};
  min-height: 100px;
  padding-bottom: ${props => (props.showBottomSeparator ? 56 : 0)}px;
  border-bottom: ${props =>
    props.showBottomSeparator ? `1px solid ${colors.grey88}` : 'none'};
  margin-bottom: ${props => (props.showBottomSeparator ? 56 : 0)}px;
`

const TitleWrapper = styled.div<{ border?: boolean }>`
  width: 100%;
  border-bottom: ${props =>
    props.border ? `1px solid ${colors.grey}` : 'none'};
`

const TitleText = styled(H5)<{ margin?: string }>`
  color: ${colors.grey08};
  font-size: 20px;
  line-height: 28px;
  margin: ${props => (props.margin ? props.margin : '16px 0 16px')};
`

interface Props {
  children: React.ReactNode
  title: string
  border?: boolean
  titleMargin?: string
  customGap?: string
  showBottomSeparator?: boolean
}
const ListingSection: React.FC<Props> = ({
  children,
  title = '',
  border,
  titleMargin,
  customGap,
  showBottomSeparator = false,
  ...rest
}) => (
  <SectionWrapper
    showBottomSeparator={showBottomSeparator}
    customGap={customGap}
    {...rest}
  >
    <TitleWrapper border={border}>
      <TitleText as="h2" margin={titleMargin}>
        {title}
      </TitleText>
    </TitleWrapper>
    {children}
  </SectionWrapper>
)

export default ListingSection
